var twoRelatedSwiperSlideCount = jQuery(".swiper.swiper--two-related-projects .swiper-slide").length;
const twoRelatedSwiper = new Swiper(".swiper.swiper--two-related-projects", {
	// Optional parameters
	loop: twoRelatedSwiperSlideCount > 1 ? true : false,
	slidesPerView: 1,
	lazy: true,
	simulateTouch: false,
	effect: 'slide',
	fadeEffect: {
		crossFade: true
	},
	observer: true,
	
	speed: 700,

	// If we need pagination
	pagination: false,

	// Navigation arrows
	navigation: {
		enabled: twoRelatedSwiperSlideCount > 1 ? true : false,
		nextEl: ".two-related-projects .swiper-button-next",
		prevEl: ".two-related-projects .swiper-button-prev",
	},

	// Responsive breakpoints
  breakpoints: {
    1200: {
      slidesPerView: 2,
			effect: 'slide',
      spaceBetween: 46,
      loop: twoRelatedSwiperSlideCount > 1 ? true : false,
			navigation: {
				enabled: twoRelatedSwiperSlideCount > 2 ? true : false,
			}
    },
    1440: {
      slidesPerView: 2,
			effect: 'slide',
      spaceBetween: 76,
      loop: twoRelatedSwiperSlideCount > 1 ? true : false,
			navigation: {
				enabled: twoRelatedSwiperSlideCount > 2 ? true : false,
			}
    },
  }
});
